// import { useState, useEffect } from "react";
import { useMemo } from "react";
import { Modal, Frame, TitleBar, Button } from "@react95/core";

import { Checkbox, Dropdown, Fieldset, Input, Tab, Tabs } from "@react95/core";

import {
  Regedit,
  Regedit205,
  Regedit206,
  FilePick,
  Mailnews8,
  Mcm3200,
  Playp16,
} from "@react95/icons";

import { useApp } from "../../context/AppContext";

import { WINDOW_NAMES } from "../../config/const";
import { getModalSizeProps } from "../../config/window";

export const RunDialogDef = {
  id: WINDOW_NAMES.RunDialog,
  title: "Run...",
  icon: <Playp16 variant="16x16_4" />,
  hasButton: false,
};

export default function RunDialog() {
  const { closeModal, status, error } = useApp();
  const icon = RunDialogDef.icon;
  const sizeProps = useMemo(() => getModalSizeProps("125px", "300px", "bottom-left"), []);

  return (
    <Modal
      key={RunDialogDef.id}
      id={RunDialogDef.id}
      icon={icon}
      title={RunDialogDef.title}
      dragOptions={sizeProps.dragOptions}
      titleBarOptions={[
        <TitleBar.Close key="close" onClick={() => closeModal(RunDialogDef.id)} />,
      ]}
      defaultClosed={true}
      hasWindowButton={false}
      height={sizeProps.height}
      width={sizeProps.width}
      dragTrail={60000}
    >
      <div
        style={{
          padding: "4px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        }}
      >
        Coming soon to an operating system near you...
      </div>
    </Modal>
  );
}
